import { render, staticRenderFns } from "./SidebarNavDropdown.vue?vue&type=template&id=566d7b2f&scoped=true&"
import script from "./SidebarNavDropdown.vue?vue&type=script&lang=js&"
export * from "./SidebarNavDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNavDropdown.vue?vue&type=style&index=0&id=566d7b2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566d7b2f",
  null
  
)

export default component.exports